import { supabase } from './supabase';

// Module-level context — set by AuthContext / OrganizationContext
let _userId: string | null = null;
let _orgId: string | null = null;

const MAX_MESSAGE_LENGTH = 2000;
const MAX_STACK_LENGTH = 5000;

/**
 * Called by context providers to keep the logger aware of current user/org.
 */
export function setErrorLoggerContext(userId: string | null, orgId: string | null) {
  _userId = userId;
  _orgId = orgId;
}

interface LogErrorParams {
  type: 'render' | 'query' | 'mutation' | 'unhandled_rejection' | 'global_error' | 'unknown';
  error: unknown;
  metadata?: Record<string, unknown>;
}

/**
 * Fire-and-forget insert into error_logs. Never throws.
 */
export function logError({ type, error, metadata }: LogErrorParams) {
  try {
    const err = error instanceof Error ? error : new Error(String(error));
    const message = (err.message || '').slice(0, MAX_MESSAGE_LENGTH);
    const stack = (err.stack || '').slice(0, MAX_STACK_LENGTH);

    // Fire and forget — don't await
    supabase
      .from('error_logs')
      .insert({
        user_id: _userId,
        organization_id: _orgId,
        error_type: type,
        error_message: message,
        stack_trace: stack,
        url: window.location.href,
        user_agent: navigator.userAgent,
        metadata: metadata ?? {},
      })
      .then(({ error: insertError }) => {
        if (insertError) {
          // Last resort — log to console so we don't lose the signal entirely
          console.warn('[error-logger] failed to persist:', insertError.message);
        }
      });
  } catch {
    // Absolutely never throw from the error logger
  }
}
